import { RSelect } from "../Component";
import { useState } from "react";
// import { MONTHS } from "../../utils/Utils";
import { MONTHS } from "../../utils/Utils";

const MonthDropDown = ({
  value,
  isMulti = false,
  isShowAll = false,
  onSelect,
  handleOnSearch,
  placeholder,
  handleOnSelect,
  inputSearchString,
  carerTypeId,
  selectedValue,
  ...props
}) => {
  const [list] = useState(MONTHS);
  const [, setSearchString] = useState("");

  const handleSearch = (text) => {
    setSearchString(text);
  };
  return (
    <RSelect
      options={list ?? []}
      isMulti={isMulti}
      placeholder={placeholder}
      value={value ?? selectedValue}
      onInputChange={handleSearch}
      onChange={(e) => {
        if (isShowAll === false) {
          onSelect(e);
        } else {
          e.id === 0 ? onSelect(undefined) : onSelect(e);
        }
      }}
      {...props}
    />
  );
};

export default MonthDropDown;
